import { PermissionsService } from "../../../routes/services/permissions.service";
import { TranslatorService } from "../../../core/translator/translator.service";
import { Component, OnInit, OnDestroy, ElementRef, HostListener } from "@angular/core";
import { SettingsService } from "../../../core/settings/settings.service";
import { localValue, StorageService } from "../../../routes/services/storage.service";
import { FeedersService } from "../../../routes/services/feeder.service";
import { UsersService } from "../../../routes/services/users.service";
import { GlobalFunction } from "../../../routes/services/globalFuntion";
import { FramesService } from "../../../routes/services/frames.service";
import { ThemesService } from "../../../core/themes/themes.service";
import { AuthService } from "../../../routes/services/auth.service";
import { FarmService } from "../../../routes/services/farm.service";
import { Subscription } from "rxjs";
import { VersioningService } from "../../../routes/Pages/versioning/services/versioning.service";

@Component({
  selector: "app-offsidebar",
  templateUrl: "./offsidebar.component.html",
  styleUrls: ["./offsidebar.component.scss"]
})
export class OffsidebarComponent implements OnInit, OnDestroy {
  currentTheme: localValue["theme"] = "D";

  feeders = [];
  user: any;

  needsRefresh: boolean = false;

  language = {
    code: "",
    text: "",
    image: ""
  };
  autimaticTestTime = { hour: 0, minute: 0 };

  mode_configuration: "global" | "sensor" = "global";
  is_client = false;
  status_test_alert: boolean = false;
  config_mode: "min-max" | "automatic" | "fuzzy-logic" = "min-max";
  /** Cierra el panel de opciones y vuelve a la seccion global. */
  closeOffsidebar(): void {
    this.settings.setLayoutSetting("offsidebarOpen", false);
    this.mode_configuration = "global";
  }

  /** Cierra el panel con la tecla Escape. */
  @HostListener("document:keydown.escape")
  onEscape(): void {
    if (!this.settings.getLayoutSetting("offsidebarOpen")) {
      return;
    }
    this.closeOffsidebar();
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    const clickedInsideSidebar = this.elem.nativeElement.contains(target);
    const clickedInsideDynamicChild = !!target.closest(".offsidebar-child");

    if (!clickedInsideSidebar && !clickedInsideDynamicChild) {
      this.settings.setLayoutSetting("offsidebarOpen", false);
      this.mode_configuration = "global";
    }
  }
  constructor(
    public permissionsService: PermissionsService,
    public versionService: VersioningService,
    public globalFunction: GlobalFunction,
    public storageService: StorageService,
    public translator: TranslatorService,
    public feederService: FeedersService,
    public framesService: FramesService,
    public usersService: UsersService,
    public settings: SettingsService,
    public authService: AuthService,
    public farmService: FarmService,
    public themes: ThemesService,
    public elem: ElementRef
  ) {
    this.user = <any>JSON.parse(localStorage.getItem("USER") || "{}");
  }
  farm: any = null;
  farmSubsciption: Subscription | undefined;
  modeSubsciption: Subscription | undefined;
  sidebarSectionSubsciption: Subscription | undefined;

  sidebar = {
    alerts: true,
    feeders: true
  };
  permissions = {
    view_refeed: true,
    view_automatic_test: true,
    view_parametricpreference: true,
    view_feedingfuzzylogic: true
  };
  mode: any = 0;
  ngOnDestroy() {
    if (this.farmSubsciption) this.farmSubsciption.unsubscribe();
    if (this.modeSubsciption) this.modeSubsciption.unsubscribe();
  }

  ngOnInit() {
    const validate_permissions = () => {
      const validate_client = (prop: string) => {
        return this.permissionsService.validatePermissionsExistClient(prop);
      };
      const validate_subclient = (prop: string) => {
        return this.permissionsService.validatePermissionsExistSubclient(prop);
      };
      this.permissions = {
        view_refeed: validate_client("view_refeed") && validate_subclient("view_refeed"),
        view_automatic_test:
          validate_client("view_automatic_test") && validate_subclient("view_automatic_test"),
        view_parametricpreference: validate_subclient("view_parametricpreference"),
        view_feedingfuzzylogic:
          validate_client("view_feedingfuzzylogic") && validate_subclient("view_feedingfuzzylogic")
      };
    };
    validate_permissions();
    if (this.storageService.localValue) {
      const personal_web = this.storageService.localValue;
      if (personal_web) {
        this.uploadPreferenceHeader(personal_web);

        this.is_client = !this.globalFunction.validateSoloAdmin() || personal_web.mode === 1;

        this.mode = Number(personal_web.mode);
        this.mode_configuration = "global";
        if (personal_web["theme"]) {
          this.currentTheme = personal_web["theme"];
          // En la carga solo se aplica el tema guardado; no se persiste para
          // evitar un PATCH redundante con el mismo valor recién leído.
          this.themes.setTheme(this.currentTheme);
        } else {
          this.currentTheme = this.themes.getDefaultTheme();
        }

        if (this.is_client) {
          const { farm_id } = this.storageService.localValue;
          farm_id && this.getFarm(farm_id);
        }
      }
    }

    this.farmSubsciption = this.storageService.watchStorage("farmId").subscribe((data: string) => {
      this.getFarm(Number(data));
      validate_permissions();
    });

    this.modeSubsciption = this.storageService.watchStorage("mode").subscribe(async (mode) => {
      this.mode = Number(mode);
      validate_permissions();

      if (this.storageService.localValue) {
        this.is_client = !this.globalFunction.validateSoloAdmin() || this.mode === 1;

        // Se descarta la granja del modo/cliente anterior hasta cargar la actual,
        // para no mostrar ni guardar configuraciones sobre una granja ajena
        this.farm = null;
        const { farm_id } = this.storageService.localValue;
        if (farm_id) {
          this.getFarm(farm_id);
        }

        this.mode_configuration = "global";
      }
    });
  }

  /**
   * Carga la granja activa y su configuracion (tests automaticos y DPI).
   * Si la granja no existe o no pertenece al cliente actual, el panel queda sin
   * granja en vez de conservar la anterior.
   * @param farmId id de la granja seleccionada.
   */
  getFarm(farmId: number) {
    if (!farmId) {
      this.farm = null;
      return;
    }
    // Sin cancelar al navegar: el panel vive en el layout, no en la ruta
    this.farmService.getFarm(farmId, "", false).subscribe(
      (resp) => {
        // Respuesta de una granja que ya no es la seleccionada (cambio rapido de cliente o granja)
        if (Number(this.storageService.localValue.farm_id) !== Number(resp.id)) {
          return;
        }
        this.farm = resp;

        if (resp.task_test_alert) {
          this.status_test_alert = resp.task_test_alert.enabled;
          const { hour, minute } = resp.task_test_alert.crontab;
          this.autimaticTestTime = {
            hour: Math.trunc(hour),
            minute: Math.trunc(minute)
          };
        }
        // La configuracion de la granja (incluido fuzzy_dpi) la carga app-configuration
      },
      () => {
        this.farm = null;
      }
    );
  }

  /**
   * Aplica el tema seleccionado y lo persiste en las preferencias del usuario
   * para recordar el último tema entre sesiones. Se invoca desde el selector de
   * temas (ngModelChange) ante una acción del usuario.
   */
  setTheme() {
    this.themes.setTheme(this.currentTheme);
    this.storageService.localValue.theme = this.currentTheme;
    this.storageService
      .editPreferences({ ...this.storageService.localValue })
      ?.subscribe(() => {
        this.storageService.localValue = { ...this.storageService.localValue };
      });
  }

  getLanguage = (
    type: "spanish" | "en"
  ): { code: "en" | "spanish"; text: string; image: string } => {
    const find = this.translator.getAvailableLanguages().find((item) => item.code === type);
    if (find) {
      return find;
    }
    return this.translator.getAvailableLanguages()[0];
  };
  changeLanguage() {
    if (this.language.code == "spanish") {
      const en = this.getLanguage("en");
      this.language = en;
      this.setLang(en);
    } else if (this.language.code == "en") {
      const spanish = this.getLanguage("spanish");
      this.language = spanish;
      this.setLang(spanish);
    }
  }

  getLangs() {
    return this.translator.getAvailableLanguages();
  }

  setLang(language: { code: "en" | "spanish"; text: string; image: string }) {
    const { code } = language;

    this.language = language;
    this.storageService.localValue.language = code;

    this.storageService
      .editPreferences({ ...this.storageService.localValue })
      ?.subscribe((resp) => {
        this.storageService.localValue = { ...this.storageService.localValue };
      });
    this.translator.useLanguage(code);
  }

  uploadPreferenceHeader(personal: localValue) {
    const getLangs: Array<any> = this.getLangs();

    if (personal["language"]) {
      const lang: any = getLangs.find((item) => item.code === personal.language);

      this.language = lang;
      this.translator.useLanguage(lang.code);
    } else {
      this.language = getLangs[0];
      this.storageService.localValue.language = getLangs[0].code;
      setTimeout(() => {
        this.translator.useLanguage("spanish");
      }, 400);
    }
  }

  checkCloseOffsidebar(e: any) {
    const contains =
      this.elem.nativeElement !== e.target && this.elem.nativeElement.contains(e.target);
    if (!contains) {
      this.settings.setLayoutSetting("offsidebarOpen", false);
      this.mode_configuration = "global";
    }
  }

  changeFont(size: "reduce" | "add" | "default") {
    this.storageService.changeFont(size);
  }
}
